"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompaniesCompanyPreviousNames$ = exports.CompaniesCompanyPreviousNames$outboundSchema = exports.CompaniesCompanyPreviousNames$inboundSchema = void 0;
exports.companiesCompanyPreviousNamesToJSON = companiesCompanyPreviousNamesToJSON;
exports.companiesCompanyPreviousNamesFromJSON = companiesCompanyPreviousNamesFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
/** @internal */
exports.CompaniesCompanyPreviousNames$inboundSchema = z.object({
    date: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    name: z.nullable(z.string()),
});
/** @internal */
exports.CompaniesCompanyPreviousNames$outboundSchema = z.object({
    date: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    name: z.nullable(z.string()),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var CompaniesCompanyPreviousNames$;
(function (CompaniesCompanyPreviousNames$) {
    /** @deprecated use `CompaniesCompanyPreviousNames$inboundSchema` instead. */
    CompaniesCompanyPreviousNames$.inboundSchema = exports.CompaniesCompanyPreviousNames$inboundSchema;
    /** @deprecated use `CompaniesCompanyPreviousNames$outboundSchema` instead. */
    CompaniesCompanyPreviousNames$.outboundSchema = exports.CompaniesCompanyPreviousNames$outboundSchema;
})(CompaniesCompanyPreviousNames$ || (exports.CompaniesCompanyPreviousNames$ = CompaniesCompanyPreviousNames$ = {}));
function companiesCompanyPreviousNamesToJSON(companiesCompanyPreviousNames) {
    return JSON.stringify(exports.CompaniesCompanyPreviousNames$outboundSchema.parse(companiesCompanyPreviousNames));
}
function companiesCompanyPreviousNamesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.CompaniesCompanyPreviousNames$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'CompaniesCompanyPreviousNames' from JSON`);
}
//# sourceMappingURL=companiescompanypreviousnames.js.map